export default __webpack_public_path__ + "static/media/GR7 4A-3B-4EC.c773142e.jpg";